import landingBg from '@/assets/images/portfolio/landing-background.jpg'
import { pageMaxWidth, pageXPadding, pageYPadding } from '@/config'
import { Helmet } from 'react-helmet-async'
import { Outlet } from 'react-router-dom'
import { useCurrentProject } from '../store/currentProject'

export const PortfolioLayout = () => {
  const currentProject = useCurrentProject()
  return (
    <>
      <Helmet title="Portfolio" />
      <section className="relative w-full">
        <div className="absolute inset-0 z-10 bg-[rgba(0,0,0,0.4)]"></div>
        <img src={landingBg} className="absolute z-0 size-full object-cover" />
        <div className={`${pageXPadding} ${pageYPadding} relative z-20`}>
          <div className={`${pageMaxWidth} mx-auto`}>
            <span
              className={
                "relative w-fit font-[nunito] text-[24px] leading-[28.8px] text-white  [font-weight:700] before:absolute before:bottom-0 before:left-0  before:w-1/2  before:border-b-2 before:border-[#8C1D40] before:content-[''] md:text-[36px] md:leading-[43.2px] lg:text-[48px] lg:leading-[57.6px]"
              }
            >
              Portfolio
            </span>

            <span className="font-nunito text-[24px] leading-[28.8px] text-white [font-weight:200] md:text-[36px] md:leading-[43.2px] lg:text-[48px] lg:leading-[57.6px]">
              {' '}
              |{' '}
            </span>
            <span className="font-nunito text-[20px] leading-[24px] text-[#D4AF37] [font-weight:700] md:text-[28px] md:leading-[33.6px] lg:text-[36px] lg:leading-[43.2px] ">
              {currentProject.project?.title}
            </span>
          </div>
        </div>
      </section>

      <section className={`${pageYPadding} ${pageXPadding}`}>
        <div className={`${pageMaxWidth} mx-auto flex flex-col gap-y-[16px]`}>
          <Outlet />
        </div>
      </section>
    </>
  )
}
